export default function StartController() {

}